import { extend } from 'flarum/common/extend';
import LogInButtons from 'flarum/forum/components/LogInButtons';
import LogInButton from 'flarum/forum/components/LogInButton';

// Updated initializer name
app.initializers.add('floxum-oidc', () => {
    extend(LogInButtons.prototype, 'items', function (items) {
        // WRAP IN TRY-CATCH to prevent crashing other extensions (like fof/oauth)
        try {
            // Updated attribute key
            const providersJson = app.forum.attribute('floxum-oidc.providers');

            // Safety check: verify it is a valid string before parsing
            if (!providersJson || typeof providersJson !== 'string') return;

            let providers = {};
            try {
                providers = JSON.parse(providersJson);
            } catch (e) {
                console.error('Floxum OIDC: Invalid JSON settings', e);
                return;
            }

            Object.keys(providers).forEach(key => {
                const p = providers[key];
                if (!p) return;

                // Safe Icon Handling
                const iconValue = p.icon || 'fas fa-id-card';
                const isUrl = iconValue.indexOf('.') > -1 && !iconValue.includes(' ');

                // Safe Style Object
                const buttonStyle = {};
                if (p.btn_bg) buttonStyle.backgroundColor = p.btn_bg;
                if (p.btn_text) buttonStyle.color = p.btn_text;
                buttonStyle.border = 'none';

                // Add to List
                items.add(`oidc-${key}`,
                    <LogInButton
                        className={`Button LogInButton--oidc LogInButton--${key}`}
                        icon={isUrl ? null : iconValue}
                        path={`/auth/oidc?provider=${key}`}
                        style={buttonStyle}>

                        {isUrl && (
                            <img
                                src={iconValue}
                                alt="icon"
                                className="Button-icon"
                                style={{
                                    height: '20px',
                                    verticalAlign: 'text-bottom',
                                    marginRight: '5px'
                                }}
                            />
                        )}

                        {p.button_title || `Log in with ${key}`}
                    </LogInButton>
                );
            });
        } catch (err) {
            console.error('Floxum OIDC Extension Error:', err);
        }
    });
});